module.exports = __webpack_public_path__ + "static/img/a112.b94ef09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a112.jpg
// module id = 7DuQ
// module chunks = 0